import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'

import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)

import { library } from '@fortawesome/fontawesome-svg-core'
import { faBars, faCheck, faPause, faPlay } from '@fortawesome/free-solid-svg-icons'
import { faFacebookF, faTwitter } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(faBars, faCheck, faFacebookF, faTwitter, faPause, faPlay)
Vue.component('font-awesome-icon', FontAwesomeIcon)

import routes from './routes';

import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

Vue.config.productionTip = false
Vue.use(VueRouter);

var SocialSharing = require('vue-social-sharing');
Vue.use(SocialSharing);

const router = new VueRouter({mode: 'history', routes});

new Vue({
    router,
    render: h => h(App),
}).$mount('#app')
